import React, { Component } from 'react';
import './index.scss';
import {observer,inject} from 'mobx-react';
import Charts from 'react-highcharts';

var HighchartsMore = require('highcharts-more');
HighchartsMore(Charts.Highcharts);

@inject("summaryDataStore")
@observer
class SumChart extends Component {

    constructor(props) {
        super(props)
        this.state = {
            percentSave: this.props.percentSave,
            config: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                    type: 'pie',
                    backgroundColor: 'rgba(0,0,0,0)',
                    height: '45%',
                    margin: [0, 0, 0, 0],
                    spacingTop: 0,
                    spacingBottom: 0,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                title: {
                    text: '15<span style="font-size:25px;font-family: DB Heavent Li">%</span>',
                    align: 'center',
                    verticalAlign: 'middle',
                    y: 45,
                    margin: 0,
                    style: {
                        fontSize: '6.4rem',
                        color: '#25bdae',
                        fontFamily: 'DB Heavent Li',
                        fontWeight: 'normal'
                    }
                },
                colors: ['#25bdae','#F5F5F5'],
                tooltip: { enabled: false },
                credits: { enabled: false },
                legend: { enabled: false },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        borderWidth: 1,
                        dataLabels: {
                            enabled: false,
                            distance: -50,
                            style: {
                                fontWeight: 'bold',
                                color: 'white'
                            }
                        },
                        startAngle: -90,
                        endAngle: 90,
                        center: ['50%', '90%'],
                        size: '160%',
                    },
                    series: {
                        animation: true,
                    }
                },
                pane: {
                    center: ['50%', '85%'],
                    size: '140%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: '#EEE',
                        innerRadius: '80%',
                        outerRadius: '100%',
                        shape: 'arc'
                    },
                    innerRadius: '80%',
                    outerRadius: '100%'
                    },
                series: [{
                    type: 'pie',
                    name: 'เปอร์เซนความประหยัด',
                    innerSize: '85%',
                    data: [['',45],['',55]],
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }]
            }
        }
    }

    componentDidMount(){
        this.setValueChart();
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.percentSave !== nextProps.percentSave){
            this.setValueChart();
        }
    }

    setValueChart() {
        const { percentSave } = this.props.summaryDataStore;
        let { config } = this.state;
        let percent = parseFloat(percentSave);
        config.series[0].data = [ ['',percent], ['', parseFloat(100-percent)] ];
        config.title.text = percent+'<span style="font-size:25px;font-family: DB Heavent Li">%</span>';
        this.setState({ config: config });
    }

    render() {
        const { config } = this.state;
        return (
            <div className='sumChart'>
                <Charts key={1} config={config} />
            </div>
        );
    }
}

export default SumChart;


// WEBPACK FOOTER //
// ./src/components/summary/sumChart.js